import { chakra } from '@plurall/elo-v3';

import {
  competitivePositionEmptyRecipe,
  competitivePositionListRecipe,
  positionItemAdvantageRecipe,
  positionItemMetaRecipe,
  positionItemMetaSeparatorRecipe,
  positionItemRankRecipe,
  positionItemRecipe,
  positionItemSchoolNameRecipe,
  positionItemSchoolRecipe,
  positionItemScoreLabelRecipe,
  positionItemScoreRecipe,
  positionItemScoreValueRecipe,
} from './CompetitivePositionCard.recipe';

export const CompetitivePositionListFactory = chakra('ol', competitivePositionListRecipe);
export const CompetitivePositionEmptyFactory = chakra('div', competitivePositionEmptyRecipe);
export const PositionItemFactory = chakra('li', positionItemRecipe);
export const PositionItemRankFactory = chakra('span', positionItemRankRecipe);
export const PositionItemSchoolFactory = chakra('div', positionItemSchoolRecipe);
export const PositionItemSchoolNameFactory = chakra('h3', positionItemSchoolNameRecipe);
export const PositionItemMetaFactory = chakra('div', positionItemMetaRecipe);
export const PositionItemMetaSeparatorFactory = chakra('span', positionItemMetaSeparatorRecipe);
export const PositionItemScoreFactory = chakra('div', positionItemScoreRecipe);
export const PositionItemScoreLabelFactory = chakra('span', positionItemScoreLabelRecipe);
export const PositionItemScoreValueFactory = chakra('strong', positionItemScoreValueRecipe);
export const PositionItemAdvantageFactory = chakra('span', positionItemAdvantageRecipe);
